export default [
  'mdiSubdirectoryArrowLeft',
  'mdiSubdirectoryArrowRight',
  'mdiArrowUp',
  'mdiArrowDown',
  'mdiArrowLeft',
  'mdiArrowRight',
  'mdiArrowTopLeft',
  'mdiArrowTopRight',
  'mdiArrowBottomLeft',
  'mdiArrowBottomRight',

  'mdiArrowUpThick',
  'mdiArrowDownThick',
  'mdiArrowLeftThick',
  'mdiArrowRightThick',
  'mdiArrowTopLeftThick',
  'mdiArrowTopRightThick',
  'mdiArrowBottomLeftThick',
  'mdiArrowBottomRightThick',

  'mdiArrowUpBold',
  'mdiArrowDownBold',
  'mdiArrowLeftBold',
  'mdiArrowRightBold',

  'mdiArrowUpBoldBox',
  'mdiArrowDownBoldBox',
  'mdiArrowLeftBoldBox',
  'mdiArrowRightBoldBox',

  'mdiArrowUpCircle',
  'mdiArrowDownCircle',
  'mdiArrowLeftCircle',
  'mdiArrowRightCircle',

  'mdiArrowUpCircleOutline',
  'mdiArrowDownCircleOutline',
  'mdiArrowLeftCircleOutline',
  'mdiArrowRightCircleOutline',

  'mdiArrowUpThinCircleOutline',
  'mdiArrowDownThinCircleOutline',
  'mdiArrowLeftThinCircleOutline',
  'mdiArrowRightThinCircleOutline',

  'mdiArrowUpBoldCircleOutline',
  'mdiArrowDownBoldCircleOutline',
  'mdiArrowLeftBoldCircleOutline',
  'mdiArrowRightBoldCircleOutline',

  'mdiArrowUpBoldHexagonOutline',
  'mdiArrowDownBoldHexagonOutline',
  'mdiArrowLeftBoldHexagonOutline',
  'mdiArrowRightBoldHexagonOutline',

  'mdiArrowUpDropCircle',
  'mdiArrowDownDropCircle',
  'mdiArrowLeftDropCircle',
  'mdiArrowRightDropCircle',

  'mdiMenuUp',
  'mdiMenuDown',
  'mdiMenuLeft',
  'mdiMenuRight',

  'mdiMenuUpOutline',
  'mdiMenuDownOutline',
  'mdiMenuLeftOutline',
  'mdiMenuRightOutline',

  'mdiChevronUp',
  'mdiChevronDown',
  'mdiChevronLeft',
  'mdiChevronRight',

  'mdiChevronDoubleUp',
  'mdiChevronDoubleDown',
  'mdiChevronDoubleLeft',
  'mdiChevronDoubleRight',

  'mdiChevronTripleUp',
  'mdiChevronTripleDown',
  'mdiChevronTripleLeft',
  'mdiChevronTripleRight',

  'mdiArrowUpDown',
  'mdiArrowLeftRight',
  'mdiArrowUpDownBold',
  'mdiArrowLeftRightBold',

  'mdiArrowUpDownBoldOutline',
  'mdiArrowLeftRightBoldOutline',

  'mdiUnfoldLessVertical',
  'mdiUnfoldMoreVertical',
  'mdiUnfoldLessHorizontal',
  'mdiUnfoldMoreHorizontal',

  'mdiPageFirst',
  'mdiPageLast',

  'mdiCursorMove',
];
